module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_DE-71f81b2e1cdf9af12a147def98a58eca.svg";